import React, { Component } from "react";
import { connect } from "react-redux";
import imgCompleted from "./../assets/img/illus-success.svg";
import {
  SaveUserStateToServerHelper,
  ExamCompletedHelper,
  CandidateConfirmationEmail,
} from "./Helper";
import { setExaminationCompleted } from "./../actions/assessment";

import { Translate } from "react-redux-i18n";
import Button from "./ui/Buttons/Button";
import SuccessIcon from "./ui/Icons/SuccessIcon";

export class Completed extends Component {
  componentDidMount() {
    this.props.setExaminationCompleted();
    SaveUserStateToServerHelper(this.props.assessment);
    ExamCompletedHelper(this.props.assessment);
  }

  render() {
    const i18n = require("react-redux-i18n").I18n;
    let redirect_url = this.props.assessment.redirect_url;
    const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;

    if (!!!redirect_url || !urlRegex.test(redirect_url)) {
      redirect_url = "https://www.psymetricsworld.com/";
    }

    return (
      <div className="main container-fluid mt-nav p-0">
        <div className="d-md-flex">
          <div className="col col-main">
            <div className="card test-alert card-body  justify-content-center">
              <div className="inner">
                {/* <img src={imgCompleted} height="150" alt={i18n.t("success")} /> */}
                <SuccessIcon size={150} className="text-success" />
                <h1 className="title">
                  <Translate value="success" />
                </h1>
                <p>
                  <Translate value="comp_test" />
                </p>
                <div className="button-wrap mt-md-5">
                  {/* <button
                    onClick={() => {
                      CandidateConfirmationEmail(this.props.assessment);

                      if (window.self !== window.top) {
                        // Try to navigate the top window first
                        try {
                          window.top.location.href = redirect_url;
                        } catch (e) {
                          // Cross-origin navigation failed, use postMessage as fallback
                          window.parent.postMessage(
                            { action: "redirect", url: redirect_url },
                            "*", // Target origin - use "*" for any origin, or specify specific origin for security
                          );
                        }
                      } else {
                        // Not in an iframe, navigate directly
                        window.location.href = redirect_url;
                      }
                    }}
                    className="btn btn-success btn-global"
                    id="close"
                  >
                    <Translate value="comp_close" />
                  </button> */}
                  {/* <button
                    className="btn btn-main btn-global"
                    id="processing"
                    disabled
                  >
                    <Translate value="exam_completion_processing" />
                  </button> */}

                  <Button
                    variant="primary"
                    id="close"
                    className="btn-global"
                    onClick={() => {
                      CandidateConfirmationEmail(this.props.assessment);

                      if (window.self !== window.top) {
                        // Try to navigate the top window first
                        try {
                          window.top.location.href = redirect_url;
                        } catch (e) {
                          // Cross-origin navigation failed, use postMessage as fallback
                          window.parent.postMessage(
                            { action: "redirect", url: redirect_url },
                            "*", // Target origin - use "*" for any origin, or specify specific origin for security
                          );
                        }
                      } else {
                        // Not in an iframe, navigate directly
                        window.location.href = redirect_url;
                      }
                    }}
                  >
                    <Translate value="comp_close" />
                  </Button>
                  <Button
                    variant="primary"
                    id="processing"
                    className="btn-global"
                    disabled
                  >
                    <Translate value="exam_completion_processing" />
                  </Button>
                </div>
                <br />
                {/* <span style={{ color: "#627081" }} id="comp_close_text">
                  <Translate value="comp_close_text" />
                </span> */}
                <span
                  style={{ color: "#627081" }}
                  className="font-weight-bold"
                  id="exam_completion_processing_text"
                >
                  <Translate value="exam_completion_processing_text" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = (dispatch) => ({
  setExaminationCompleted: () => dispatch(setExaminationCompleted()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Completed);
